import { render } from "./BookingPages.vue?vue&type=template&id=5ca800ac&scoped=true"
import script from "./BookingPages.vue?vue&type=script&scoped=true&lang=js"
export * from "./BookingPages.vue?vue&type=script&scoped=true&lang=js"

import "./BookingPages.vue?vue&type=style&index=0&id=5ca800ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca800ac"]])

export default __exports__